import { render, staticRenderFns } from "./recommendList.vue?vue&type=template&id=995fac26&"
import script from "./recommendList.vue?vue&type=script&lang=js&"
export * from "./recommendList.vue?vue&type=script&lang=js&"
import style0 from "./recommendList.vue?vue&type=style&index=0&id=995fac26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports